import { action, persist } from 'easy-peasy';
import type { Action } from 'easy-peasy';

export interface CorrectionFilterModel {
    showContext: boolean;
    setShowContext: Action<CorrectionFilterModel, boolean>;
    showSolution: boolean;
    setShowSolution: Action<CorrectionFilterModel, boolean>;
    showRemarks: boolean;
    setShowRemarks: Action<CorrectionFilterModel, boolean>;
    showCandidate: boolean;
    setShowCandidate: Action<CorrectionFilterModel, boolean>;
    showParticipantNames: boolean;
    setShowParticipantNames: Action<CorrectionFilterModel, boolean>;
}

export const correctionFilter: CorrectionFilterModel = persist({
    showContext: true,
    setShowContext: action((state, showContext) => {
        state.showContext = showContext;
    }),
    showSolution: false,
    setShowSolution: action((state, showSolution) => {
        state.showSolution = showSolution;
    }),
    showRemarks: true,
    setShowRemarks: action((state, showRemarks) => {
        state.showRemarks = showRemarks;
    }),
    showCandidate: true,
    setShowCandidate: action((state, showCandidate) => {
        state.showCandidate = showCandidate;
    }),
    showParticipantNames: true,
    setShowParticipantNames: action((state, showParticipantNames) => {
        state.showParticipantNames = showParticipantNames;
    }),
});
